import "./lib/polyfills"; // must run before any module that uses structuredClone at import time
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App.tsx";
import "./index.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { queryClient } from "./lib/queryClient";
import { initSentry, Sentry } from "./lib/sentry";
import { initClientSignature } from "./lib/clientVersion/initClientSignature";
import ErrorBoundary from "./components/ErrorBoundary";

// Initialize Sentry before rendering
initSentry();
// Signature de version posée sur chaque requête (X-Client-Info).
void initClientSignature();

// Expose Sentry globally for console testing
declare global {
  interface Window {
    Sentry: typeof Sentry;
  }
}
if (typeof window !== 'undefined') {
  window.Sentry = Sentry;
}

// Ensure page starts at the top on initial load/refresh
if (typeof window !== 'undefined') {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // If a hash is present (e.g., #benefits), remove it to avoid auto-scrolling
  if (window.location.hash) {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

